const DEFAULT_DEADLINE = 300; // 5 min
const LIVE_STATISTICS_SUPPORTED_SPORTS = [33, 31, 45, 26];
const LIVE_STATISTICS_SUPPORTED_PROVIDERS = [6];
const cookieKeys = {
    appChainId: 'appChainId',
    live: 'live',
};
const localStorageKeys = {
    betslipItems: 'betslipItems-v3',
};export{DEFAULT_DEADLINE as D,LIVE_STATISTICS_SUPPORTED_SPORTS as L,LIVE_STATISTICS_SUPPORTED_PROVIDERS as a,cookieKeys as c,localStorageKeys as l};